import { Container, Grid, Paper } from '@material-ui/core'
import React, { useState } from 'react'
import { components, useTranslation } from 'cng-web-lib'

import TransactionLogViewForm from './TransactionLogViewForm'
import TransactionLogEditForm from './TransactionLogEditForm'
import { useParams } from 'react-router-dom'
import Namespace from 'src/constants/locale/Namespace'
import TransactionLogKeys from 'src/constants/locale/key/TransactionLog'

const { CngTabs } = components


function EditPage({ showNotification }) {
  const { id } = useParams()
  const { translate } = useTranslation([Namespace.TRANSACTION_LOG])
  const translatedTextsObject = makeTranslatedTextsObject()
  const [transactionLog, setTransactionLog] = useState({})

  function makeTranslatedTextsObject() {
    let transactionLog = translate(
      Namespace.TRANSACTION_LOG,
      TransactionLogKeys.TITLE
    )

    return {
      transactionLog
    }
  }

  return (
    <Grid container spacing={3}>
      {/* <Grid item xs={12}>
        <Paper>
          <Container maxWidth='xl'>
            <TransactionLogViewForm
              showNotification={showNotification}
              id={id}
              onFetchPreSuccess={(datum) => {
              }}
            />
          </Container>
        </Paper>
      </Grid> */}
      <Grid item xs={12}>
        <CngTabs
          headerColor='primary'
          tabs={[
            {
              tabName: translatedTextsObject.transactionLog,
              tabContent: (
                <TransactionLogEditForm
                  showNotification={showNotification}
                  id={id}
                  onFetchPreSuccess={(datum) => {
                    setTransactionLog(datum)
                  }}
                  items={transactionLog}
                />
              )
            },
          ]}
        />
      </Grid>
    </Grid>
  );
}

export default EditPage